import Box from "@mui/material/Box";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import NavBarLandingPage from "./NavBarLandingPage";
import FooterLandingpage from "./FooterLandingpage";
import Yellowish from "../../assets/images/yellowishcircular.svg";
import SSSYmbolWhite from "../../assets/images/sssymbolwhite.svg";
import "../../assets/css/footer.css";
import "../../assets/css/animated.css";
import CircularRound from "../../assets/images/circular lining.svg";
import ContactEmailForm from "./ContactusForm/ContactEmailForm";
import { useResponsive } from "../../hooks/use-responsive";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function Contactus() {

  const mdUp = useResponsive("up", "md");
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "50px",
      fontWeight: 700,
      lineHeight: "60px",
      letterSpacing: "0em",
      textAlign: "center",
      "@media (max-width: 600px)": {
        fontSize: "32px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };

  const smallContent = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "27px",
      letterSpacing: "0em",
      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };

  const description = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "22px",
      fontWeight: 500,
      lineHeight: "27px",
      letterSpacing: "0em",
      "@media (max-width: 600px)": {
        fontSize: "16px",
        textAlign: "center",
      },
    },
  };
  const textStyle = {
    fontFamily: "Roboto Flex",
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "25.6px",
    color: "#858585"
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div>
      <NavBarLandingPage />
      <div className="landing-page">
        <div className="Contactus-container">
          <Box
            sx={{
              backgroundColor: "#f1f1f1",
              borderRadius: "15px",
              margin: "2%",
              padding: "5%",
              position: "relative",
              zIndex: "1",
              "@media screen and (max-width: 700px)": {
                padding: "10px",
              },
            }}
          >
            <img
              src={SSSYmbolWhite}
              alt=""
              className="s-symbol-used-in-the-resposnive-top-of-the-contactus"
            />
            <div style={{ position: "relative" }}>
              <Typography
                sx={{
                  ...styles.typography,
                  color: "#1E53E8",
                  marginTop: "50px",
                  height: "50px",
                  position: "relative",
                  zIndex: 2,
                  textTransform: "uppercase",
                }}
              >
                Contact Us
              </Typography>
              <img src={Yellowish} alt="" className="yellowish-circular-bg" />
              <Typography
                sx={{
                  ...description.typography,
                  fontSize: "18px",
                  fontWeight: 400,
                  textAlign: "center",
                  marginBlock: "15px",
                  position: "relative",

                }}
              >
                We're here to help! Our friendly support team is <br />
                just a click or call away.
              </Typography>
            </div>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="icon tabs example"
              centered
              variant="fullWidth"
              sx={{
                // display: 'flex',
                // justifyContent: 'space-between',
                // alignItems: 'center', // Center-align tabs vertically
                // padding: '15px 20px', // Add padding to create gap

                backgroundColor: "",
                marginTop: "70px",

              }}
            >
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "15px",
                      gap: "10px",
                      marginBottom: "20px",
                      "@media (max-width: 800px)": {
                        display: "flex",
                        flexDirection: "row",
                        padding: "20px",
                        marginBottom: "20px"

                      },
                    }}
                  >
                    <MailOutlineIcon sx={{
                      color: "#000000", fontSize: "2.5rem",
                      "@media (max-width: 800px)": {
                        fontSize: "1.5rem"
                      },
                    }} />
                    <Typography
                      sx={{
                        color: "#000000",
                        fontFamily: "Sofia Sans Extra Condensed",
                        fontSize: "40px",
                        fontWeight: "700",
                        "@media (max-width: 800px)": {
                          fontSize: "1.5rem"
                        },
                      }}
                    >
                      Email
                    </Typography>
                  </Box>
                }
                sx={{
                  padding: "15px",
                  width: "100px",
                  backgroundColor: "#FFFFFF",
                  border: "2px solid #1E53E8",
                  borderTopLeftRadius: "22px",
                  borderTopRightRadius: "22px",
                  "&.Mui-selected": {
                    backgroundColor: "#1E53E8",
                    "& .MuiTypography-root": {
                      color: "#C7F760", // Yellow color for the label when selected
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#C7F760", // Yellow color for the icon when selected
                    },
                  },
                }}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "15px",
                      gap: "10px",
                      marginBottom: "20px",
                      "@media (max-width: 800px)": {
                        display: "flex",
                        flexDirection: "row",
                        padding: "20px",
                        marginBottom: "20px"
                      },
                    }}
                  >
                    <CallIcon sx={{
                      color: "#000000", fontSize: "2.5rem",
                      "@media (max-width: 800px)": {
                        fontSize: "1.5rem"
                      },
                    }} />
                    <Typography
                      sx={{
                        color: "#000000",
                        fontFamily: "Sofia Sans Extra Condensed",
                        fontSize: "40px",
                        fontWeight: "700",
                        "@media (max-width: 800px)": {
                          fontSize: "1.5rem"
                        },
                      }}
                    >
                      Call
                    </Typography>
                  </Box>
                }
                sx={{
                  padding: "25px",
                  width: "100px",
                  border: "2px solid #1E53E8",
                  backgroundColor: "#FFFFFF",
                  borderTopLeftRadius: "22px",
                  borderTopRightRadius: "22px",
                  marginRight: "4px",
                  "& .MuiTab-root": {

                  },
                  "&.Mui-selected": {
                    backgroundColor: "#1E53E8",
                    "& .MuiTypography-root": {
                      color: "#C7F760", // Yellow color for the label when selected
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#C7F760", // Yellow color for the icon when selected
                    },
                  },
                }}
              />
            </Tabs>
            <Box
              sx={{
                width: "98.59%",
                background: "#fff",
                border: "2px solid #1E53E8",
                borderRadius: "25px",
                position: "relative",
                top: "-25px",
                "@media screen and (max-width: 700px)": { width: "96.8%" },
                "@media screen and (max-width: 400px)": { width: "95%" },
              }}
            >
              <TabPanel
                value={value}
                index={0}
                style={{
                  overflow: 'hidden', // Hide overflow
                  position: 'relative', 
                  justifyContent:'center',
                  alignItems:'center'
                }}
              >
                <ContactEmailForm />

               {mdUp && <img
                  src={CircularRound}
                  alt=""
                  style={{
                    position: "absolute",
                    bottom: "-120px",
                    right: "-50px",
                    width: "35%",
                    zIndex: "0",
                  }}
                />}
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Box
                  sx={{
                    padding: "50px",
                    position: "relative",
                    zIndex: "1",
                    "@media screen and (max-width: 700px)": {
                      padding: "0px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      ...smallContent.typography,
                      textAlign: "left",
                      marginBlock: "15px",
                    }}
                  >
                    Call Us Anytime : 9:00AM to 6:00PM
                  </Typography>
                  <Box
                    sx={{
                      // padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "space-between",
                      gap: "506px",
                      marginTop: "40px",
                      "@media screen and (max-width: 700px)": {
                        gap: "4px",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column"
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        ...description.typography,
                        textAlign: "left",
                        marginBlock: "5px",
                      }}
                    >
                      Customer support
                    </Typography>
                    <Typography
                      sx={{
                        ...description.typography,
                        textAlign: "left",
                        marginBlock: "5px",
                        color: "rgba(29, 83, 231, 1)",
                        position: "relative",
                        zIndex: "1",
                        "@media screen and (max-width: 700px)": {
                          marginTop: "24px"
                        },
                      }}
                    >
                      +91 9049999935
                    </Typography>
                  </Box>
                  {/* <div style={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
  <Typography sx={{ ...description.typography, textAlign: 'left',
 marginBlock: "15px",
 color: '#858585'
}}>
Cloud PC related issue’s
</Typography>
<Typography sx={{ ...description.typography, textAlign: 'left',
 marginBlock: "15px",
 color: '#858585',position:'relative',zIndex:'1'
}}>
+91 9049999935
</Typography>
</div>
<div style={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
  <Typography sx={{ ...description.typography,  textAlign: 'left',
 marginBlock: "15px",
 color: '#858585',position:'relative',zIndex:'1'
}}>
Complaint helpline number
</Typography>
<Typography sx={{...description.typography,   textAlign: 'left',
 marginBlock: "15px",
 color: '#858585',position:'relative',zIndex:'1'
}}>
+91 9049999935
</Typography>
</div> */}
                  <img
                    src={CircularRound}
                    alt=""
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "-24px",
                      width: "13%",
                      zIndex: "0",
                    }}
                  />
                </Box>
              </TabPanel>
            </Box>
            <img
              src={SSSYmbolWhite}
              alt=""
              className="s-symbol-used-in-the-resposnive-bottom-of-the-contactus"
            />
          </Box>
        </div>
      </div>
      <FooterLandingpage />
    </div>
  );
}

export default Contactus;
